var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import * as d3 from "d3";
import * as L from "leaflet";
import ViewState from "../viewState";
import Markers from "../mpoints/markers";
import Hulls from "../mpoints/hulls";
//import WorkSpace from "../workSpace/workSpace";
import GeneralUtil from "../../utils/generalUtil";
import AppSettings from "../appSettings";
import MapBase from "./mapBase";
//import MpointHoverCircle from "../mpoints/mpointHoverCircle";
import { MapAppMode } from "../../models/metMap/mapAppMode";
import { AlarmLevel } from "../../models/metMap/forecastResult";
//För leaflet 0.7.x. Senare versioner: buggig zoomning.
export default class MPointMap extends MapBase {
    mapSize() { return this._width * this._height; }
    ;
    getBox() {
        return {
            x: this._x, y: this._y, width: this._width, height: this._height
        };
    }
    get mPointMarkersInView() { return ViewState.mPointMarkers.filter(m => this.isInView(m)); }
    isInView(mMarker) {
        return (mMarker.x > this._x && mMarker.x < (this._x + this._width)
            &&
                mMarker.y > this._y && mMarker.y < (this._y + this._height));
    }
    constructor(htmlElement, mapMode) {
        super();
        try {
            const mapId = "#met-map";
            this._map = L.map(htmlElement, { zoomControl: mapMode === MapAppMode.PQWEB }) // disable user zoom control
                .setView(L.latLng(0, 0), 13); //dummy start point
            L.tileLayer("https://{s}.basemaps.cartocdn.com/light_all/{z}/{x}/{y}.png", {
                maxZoom: 18,
                attribution: 'Map data &copy; <a href="http://openstreetmap.org">OpenStreetMap</a> contributors, ' +
                    '<a href="http://creativecommons.org/licenses/by-sa/2.0/">CC-BY-SA</a>, ' +
                    'Imagery © <a href="http://mapbox.com">Mapbox</a>',
                id: 'examples.map-i86knfo3'
            }).addTo(this._map);
            this._map._initPathRoot();
            this.overlay = d3.select(mapId)
                .select("svg");
            d3.select(mapId).style('cursor', 'default');
            //if (mapMode === MapAppMode.PQ4CAST) {
            //    new WorkSpace(this);
            //}
        }
        catch (error) {
            GeneralUtil.handleError("Failed at mpointMap constructor", error);
        }
    }
    init(dotNetRef, rawMPoints) {
        ViewState.init(dotNetRef, rawMPoints);
    }
    draw() {
        if (ViewState.mapMPoints.length > 0)
            this.zoomToFitMarkers(ViewState.mapMPoints);
        const g = this.overlay.append("g");
        this._markers = new Markers(this);
        this._hulls = new Hulls(this);
        this._map
            .on("viewreset", this.updateMapCoords.bind(this))
            .on("moveend", this.updateMapCoords.bind(this));
        this.overlay.on("click", () => {
            if (AppSettings.AppMode === MapAppMode.PQ4CAST) {
                //if (!this.isMouseInHoverCircle()) {
                //    MpointHoverCircle.unHover(true);
                //    WorkSpace.hideWorkspace();
                //}
            }
            else if (AppSettings.AppMode === MapAppMode.PQWEB) {
                ViewState.dotNetRef.invokeMethodAsync('OnJsUnClickMPointMarker', null);
            }
        });
        this.overlay.on("dblclick", () => {
            this.zoomToFitMarkers.call(this, ViewState.mapMPoints);
        });
        this.updateMapCoords();
        if (ViewState.mapMPoints.length > 0)
            this.zoomToFitMarkers(ViewState.mapMPoints);
    }
    updateSelectedMPoints(selectedMPointIds) {
        if (AppSettings.AppMode === MapAppMode.PQWEB) {
            ViewState.mPointMarkers.forEach(mp => mp.selectMode =
                selectedMPointIds.length === 0 ? 3 :
                    selectedMPointIds.some(id => mp.mpointId === id) ? 1 :
                        2);
            this._markers.updateBlazorIcons();
            this._hulls.update();
        }
    }
    updateMPointStatuses(mpointStatuses) {
        ViewState.mapMPoints.forEach(mp => {
            const statusMPoint = mpointStatuses.find(s => s.mpointId === mp.id);
            if (statusMPoint && statusMPoint.status <= AlarmLevel.AboveMax) {
                mp.pqStatus = statusMPoint.status;
                mp.notificationStatus = statusMPoint.notificationStatus;
            }
            this._markers.updateBlazorIcons();
        });
    }
    switchAppMode() {
        this.zoomToFitMarkers(ViewState.mapMPoints);
    }
    zoomToFitMarkers(mpoints) {
        const lMarkers = this.leafletMarkers(mpoints);
        let latLongBounds = L.featureGroup(lMarkers).getBounds();
        let paddingOptions = {};
        //magic numbers, marginaler blir inte som förväntat tyvärr
        if (AppSettings.AppMode === MapAppMode.POWMON) {
            paddingOptions = {
                paddingTopLeft: L.point(210 + 540, //banner with padding + prognosis chart with padding
                20),
                paddingBottomRight: L.point(20 + 840, //infolayer padding + forecast chart with padding
                60 + 438) //footer with padding + bottom bar chart with padding
            };
        }
        else if (AppSettings.AppMode === MapAppMode.PQ4CAST) {
            paddingOptions = {
                paddingTopLeft: L.point(10, 0),
                paddingBottomRight: L.point(300, 0)
            };
        }
        if (lMarkers.length === 1) {
            let pad = Math.abs(this.mapBounds.getNorthEast().lng - this.mapBounds.getNorthWest().lng) / 100;
            pad = Math.max(pad, 0.001);
            const newSW = latLongBounds.getSouthWest(), newNE = latLongBounds.getNorthEast();
            newSW.lat -= pad;
            newSW.lng -= pad;
            newNE.lat += pad;
            newNE.lng += pad;
            latLongBounds = L.latLngBounds(newSW, newNE);
        }
        this._map.invalidateSize();
        this._map.fitBounds(latLongBounds, paddingOptions);
    }
    updateData(mpoints = []) {
        return __awaiter(this, void 0, void 0, function* () {
            this._markers.updateData(mpoints.map(mpoint => mpoint.id));
        });
    }
    updateMapCoords() {
        const mapSize = this._map.getSize();
        this._width = mapSize.x;
        this._height = mapSize.y;
        this.mapBounds = this._map.getBounds();
        this._x = this._map.latLngToLayerPoint(this.mapBounds.getNorthWest()).x;
        this._y = this._map.latLngToLayerPoint(this.mapBounds.getNorthWest()).y;
        ViewState.mPointMarkers
            .forEach(this.updateMarkerCoordinates.bind(this));
        this._markers.updateCoords();
        if (AppSettings.SHOW_HULLS)
            this._hulls.update();
    }
    updateMarkerCoordinates(marker) {
        marker.x = this._map.latLngToLayerPoint(L.latLng(marker._mpoint.lat, marker._mpoint.long)).x;
        marker.y = this._map.latLngToLayerPoint(L.latLng(marker._mpoint.lat, marker._mpoint.long)).y;
    }
    leafletMarkers(mpoints) {
        const markers = mpoints
            .map(mp => { return new L.Marker(L.latLng(mp.lat, mp.long)); });
        return markers;
    }
}
